import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import AltRouteIcon from '@mui/icons-material/AltRoute'
import BaseNode from './BaseNode'
import { ParseNodeData } from '../types'

const ParseNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as ParseNodeData
  const subtitle = nodeData.parserId
    ? `${nodeData.parserId} · ${nodeData.mode}`
    : 'Select parser...'

  return (
    <BaseNode
      nodeType="parse"
      icon={<AltRouteIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    />
  )
}

export default memo(ParseNode)
